import React, { useState } from "react";
import { TextFieldProps, InputAdornment, IconButton } from "@material-ui/core";
import { Visibility as VisibilityIcon, VisibilityOff as VisibilityOffIcon } from "@material-ui/icons";
import { PlainTextField } from "components";

// password text field
const PasswordTextField = (props: TextFieldProps) => {
    // ui state
    const [showPassword, setShowPassword] = useState(false);

    // render
    return (
        <PlainTextField
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                        </IconButton>
                    </InputAdornment>
                ),
            }}
            type={showPassword ? "text" : "password"}
            {...props}
        />
    );
};

export default PasswordTextField;
